import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 140px);
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
`;

const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
`;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 40px;
  gap: 16px;
`;

const ErrorTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #3c3c3c;
  margin: 0;
`;

const ErrorMessage = styled.p`
  font-size: 14px;
  color: #757575;
  margin: 0;
  max-width: 400px;
`;

const NotProvisionedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 40px;
  gap: 24px;
`;

const NotProvisionedTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #3c3c3c;
  margin: 0;
`;

const NotProvisionedMessage = styled.p`
  font-size: 16px;
  color: #757575;
  margin: 0;
  max-width: 500px;
  line-height: 1.5;
`;

const LaunchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
  gap: 24px;
`;

const LaunchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #EFF6FF;
  border-radius: 50%;
`;

const LaunchTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
`;

const LaunchDescription = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  max-width: 500px;
  line-height: 1.6;
`;

const FeatureList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 16px 0;
  max-width: 500px;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  text-align: left;
`;

const FeatureIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3B82F6;
  flex-shrink: 0;
`;

export default {
  Wrapper,
  IframeContainer,
  LoadingContainer,
  ErrorContainer,
  ErrorTitle,
  ErrorMessage,
  NotProvisionedContainer,
  NotProvisionedTitle,
  NotProvisionedMessage,
  LaunchContainer,
  LaunchIcon,
  LaunchTitle,
  LaunchDescription,
  FeatureList,
  FeatureItem,
  FeatureIcon,
};
